import { Dialog, DialogTitle, Typography, DialogContent, Button, Grid, TextField, MenuItem, DialogActions } from "@material-ui/core"
import { applicationContext } from "helpers/services"
import { useContext, useState } from "react"
import { ticketContext } from "./../TicketContext"


let UpdateTicketStatus = () => {
    let { ticketStatuses } = useContext(applicationContext)
    let { ticket, updateTicketStatus, statusDialog } = useContext(ticketContext)

    let [ticketStatusId, setTicketStatusId] = useState(statusDialog.suggestedStatus ?? ticket.ticketStatusId);


    return (
        <Dialog maxWidth="sm" fullWidth open={true}>
            <DialogTitle disableTypography>
                <Typography variant="h4">Ticket status</Typography>
            </DialogTitle>
            <DialogContent >
                <Grid container >
                    <Grid item xs={12}>
                        <Typography>
                            Do you want to change the current status?
                        </Typography>


                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Ticket status"
                            fullWidth
                            select
                            variant="outlined"
                            value={ticketStatusId}
                            onChange={(e) => setTicketStatusId(e.target.value)}
                        >
                            {ticketStatuses.map(status =>
                                <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                            )}
                        </TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography color="primary" variant="subtitle2">
                            {statusDialog.error}
                        </Typography>
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                {/* <Button color="primary" onClick={() => setStatusDialog({ open: false, suggestedStatus: '' })}>
                    Keep current status
                </Button> */}

                <Button
                    color="secondary"
                    onClick={async () => await updateTicketStatus(ticketStatusId)}
                >
                    Change status
                </Button>
            </DialogActions>
        </Dialog>
    )
}


export default UpdateTicketStatus